export class DeferWebComponent extends HTMLElement {
	constructor() {
		super();
	}

	static get observedAttributes() {
		return ['data-ready'];
	}
	attributeChangedCallback(name, old, value) {
		// when defined it triggers an attribute change from `null` to `""`
		if (name === 'data-ready' && value === 'true') {
			this.ready();
		}
	}
}
